// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:00:47

export default {
  "id": "doge-bubble",
  "slug": "doge-bubble",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/bd7028e2867c458db7e916b3d3f0513f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/bd7028e2867c458db7e916b3d3f0513f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Doge Bubble",
      "description": "Doge Bubble is a classic bubble shooter game with multiple challenging levels. Doge Bubbles features the classic bubble shooter gameplay with 3 powerups: The rocket that clears the chosen path, the bomb that clears up to 8 bubbles at a time and the multi color bubble. The goal in each level is to \"free\" all the doge bubbles.",
      "instructions": "Swipe to aim and shoot the bubbles! Match three or more bubbles to remove them from the board. Clear all doge bubbles and use boosters to help you in challenging levels.",
      "genres": [
        "Bubble Shooter"
      ],
      "tags": [
        "bubble"
      ]
    },
    "zh-CN": {
      "title": "狗狗泡泡",
      "description": "Doge Bubble是一款经典的泡泡射击游戏，拥有多个挑战关卡。Doge Bubbles拥有经典的泡泡射击玩法，并包含3种特殊道具：火箭道具可以清除所选路径上的泡泡，炸弹道具可以一次性清除多达8个泡泡，以及多彩泡泡道具。每个关卡的目标是“释放”所有Doge泡泡。",
      "instructions": "滑动瞄准射击泡泡！匹配三个或更多泡泡以将它们从棋盘上移除。清除所有狗狗泡泡并使用增强器来帮助你在挑战性关卡中。",
      "genres": [
        "泡泡龙"
      ],
      "tags": [
        "气泡"
      ]
    },
    "zh-TW": {
      "title": "狗狗泡泡",
      "description": "Doge Bubble 是一款經典的泡泡射擊遊戲，具有多個挑戰等級。Doge Bubbles 特點是經典的泡泡射擊遊戲玩法，並包含 3 個加成：火箭可以清除選定的路徑，炸彈可以一次清除最多 8 個泡泡，以及多顏色的泡泡。每個等級的目標是“解放”所有 Doge 泡泡。",
      "instructions": "滑動以對準並射擊泡泡！匹配三個或更多泡泡以將其從遊戲板上移除。清空所有狗狗泡泡並使用加強器幫助你在挑戰關卡中。",
      "genres": [
        "泡泡射手"
      ],
      "tags": [
        "泡泡"
      ]
    },
    "zh-HK": {
      "title": "狗狗泡泡",
      "description": "Doge Bubble 係一款經典嘅泡泡射擊遊戲，佈滿多重挑戰級別。Doge Bubbles 保留咗經典泡泡射擊遊戲嘅玩法，並提供 3 咁強力嘅加成：火箭可以清除選定路徑嘅泡泡、炸彈可以一次過清除最多 8 咁多泡泡，而多顏色泡泡則係可以一次過射擊多種顏色嘅泡泡。每個級別嘅目標就係要「釋放」所有嘅 Doge 泡泡。",
      "instructions": "滑動以定標靶及射擊泡泡！匹配三個或以上泡泡以將其從遊戲板上移除。清除所有狗狗泡泡並使用加強器來幫助你在挑戰級別中獲勝。",
      "genres": [
        "泡泡射擊"
      ],
      "tags": [
        "泡泡"
      ]
    },
    "ja": {
      "title": "ドジー・バブル",
      "description": "Doge Bubbleは、複数の挑戦的なレベルを持つクラシックなボブルシューターゲームです。Doge Bubblesは、選択されたパスをクリアするロケット、一度に最大8つのボブルをクリアする爆弾、およびマルチカラーのボブルの3つのパワーアップを特徴とするクラシックなボブルシューターゲームプレイを提供します。各レベルのゴールは、すべてのDogeボブルを「解放」することです。",
      "instructions": "スワイプして目标を定め、バブルを撃つ！三つ以上のバブルをマッチして、ボードから消去する。すべてのドogeバブルを消去し、ブースターを使って難しいレベルを乗り越える。",
      "genres": [
        "バブルシューター"
      ],
      "tags": [
        "泡"
      ]
    },
    "ko": {
      "title": "도지 부블러",
      "description": "도그 버블은 다양한 도전적인 레벨을 가진 클래식 버블 쏘아주기 게임입니다. 도그 버블은 클래식 버블 쏘아주기 게임을 기반으로 3가지 파워업을 제공합니다: 선택된 경로를 clears하는 로켓, 한 번에 최대 8개의 버블을 clears하는 지뢰, 다중 색상 버블. 각 레벨의 목표는 \"freedom\"을 주는 모든 도그 버블을 \"free\"하는 것입니다.",
      "instructions": "빙글쳐 목표를 정하고 발사하세요! 세 개 이상의 볼을 일치시켜 보드에서 제거하세요. 모든 도지 볼을 클리어하고 보스 레벨에서 도와주는 보스터를 사용하세요.",
      "genres": [
        "버블 셔터"
      ],
      "tags": [
        "발포"
      ]
    },
    "fr": {
      "title": "Chien de Bubble",
      "description": "Doge Bubble est un jeu de tire-bulle classique avec plusieurs niveaux défiants. Doge Bubbles propose le gameplay classique du tire-bulle avec 3 powerups : le fusée qui nettoie le chemin choisi, la bombe qui nettoie jusqu'à 8 bulles à la fois et la bulle multicolore. Le but de chaque niveau est de \"libérer\" toutes les bulles Doge.",
      "instructions": "Faites glisser pour viser et tirer sur les bulles ! Cochez trois bulles ou plus pour les supprimer du plateau. Éliminez toutes les bulles de Shiba Inu et utilisez des boosters pour vous aider dans les niveaux délicats.",
      "genres": [
        "Tirer des Bulles"
      ],
      "tags": [
        "bulle"
      ]
    }
  }
};
